import { ModulesMap, ModulesConfigMap } from "../modulesMaps"

// Declaration of static mock objects with using MODULES SCHEMA
export default  {
	[ModulesConfigMap[ModulesMap.USER].GET_DATA]: {
		last_login: '2022-10-18T08:09:18+00:00', // Время последнего логина
		name: 'John Doe', // Имя
		is_active: 1, // Определяет Активен/Отключен ли пользователь
		is_staff: 0, // Является ли аккаунт сотрудником АгроОнлайн - открывает дополнительные возможности
		email_confirm: 1, // Подтвержден email - позволяет начать работать с системой
		date_joined: '2021-15-10T11:02:58+00:00', // Время регистрации
		language_code: 'ru', // Выбранный язык
		avatar: 'https://picsum.photos/1000/800', // Фото (путь)
		avatar_256x256: 'https://picsum.photos/256/256', // Уменьшенное фото (путь)
	},
	[ModulesConfigMap[ModulesMap.USER].GET_CACHE_VERSION]: {
		userPermissions: 'v2',
		key2: 'csfdbhu123dfvni',
		key3: 'dscnjk12njsdcds'
	}
}
